<template lang="pug">
  section#works
    .section-title works.
    .work-list
      router-link(:to="$route.path + '/' + work.workTitle.en.toLowerCase().replace(/ /g, '-').replace(/\\?/g, '') " class="link" v-for="work in works" :key="work.id")
        WorkBox(:work="work")
    transition(name="work-detail")
      WorkDetail(:work="nowWork" :screenSize="screenSize" v-if="Object.keys(nowWork).length !== 0 && $route.path.split('/').length > 2")
</template>

<script>
import WorkBox from './WorkBox'
import WorkDetail from './WorkDetail'

export default {
  name: 'Works',
  components: { WorkBox, WorkDetail },
  props: ['screenSize'],
  data () {
    return {
      works: [
        {
          id: 10,
          workType: "work",
          workTitle: {
            en: "Word Game",
            zh: "文字遊戲"
          },
          workInfo: "//game",
          workImg: require("@/assets/images/word-game/cover.jpg"),
          workDetail: {
            info: [
              "Role: co-producer, game engineer, tech artist, acting engineer, sound director",
              "Media: digital game / godot engine / computer",
              "",
              "擔任《文字遊戲》共同製作人、程式開發、技術美術、演出工程、聲音監督，《文字遊戲》是一款全以文字組成的解謎RPG遊戲，於2022年初發售，全球銷售量已超過八萬套，總金額超過兩千萬台幣，並榮獲全球各國遊戲相關獎項。",
              "",
              "共同製作人部分，與團隊共同發想遊戲企劃、形式、劇情安排等，並從技術觀點出發評估可行性。",
              "程式開發部分，使用開源遊戲引擎Godot作為基礎，開發獨特的文字渲染邏輯與互動機制系統，並製作便於內部使用的地圖與演出編輯器。",
              "技術美術部分，利用OpenGL shader與生成式演算法，製作遊戲中包含2D與3D多數的視覺效果。",
              "演出工程與聲音監督部分，依照分鏡實作遊戲中約九成的劇情演出與謎題邏輯，並調整遊戲內配樂、音效與演出之間的平衡。",
              "",
              "獎項",
              "2021 Indie Game Award | 最佳創新獎",
              "2021 Indie Live Expo Awards | 最佳地域文化獎",
              "2020 Indie Play Award | 最佳聽覺效果獎",
              "2020 巴哈姆特ACG創作大賽遊戲組 | 金賞、最佳創意獎",
              "",
              "> <a href='https://store.steampowered.com/app/1109570/' target='_blank'>steam store</a>"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p1.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p2.jpg")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p3.jpg")
                  }
                ],
                options: {
                  isFixedHeight: false
                }
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p4.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p5.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/word-game/p6.png")
                  }
                ],
                options: {
                  isFixedHeight: false
                }
              },
            ],
            videos: [
              {
                img: require("@/assets/images/word-game/p1.jpg"),
                id: "pBzFgfKJnPI"
              }
            ]
          }
        },
        {
          id: 9,
          workType: "work",
          workTitle: {
            en: "Panorama",
            zh: "全景影像"
          },
          workInfo: "//teaching",
          workImg: require("@/assets/images/panorama/cover.jpg"),
          workDetail: {
            info: [
              "Role: teacher",
              "Media: 360 degree video / Adobe Pr / Adobe Ae / Aframe.js",
              "",
              "擔任清華大學藝術學院二年級必修課《全景影像》之教師，在課程中帶領學生認識虛擬實境藝術與錄像藝術之概念與作品鑒賞，教導如何使用全景攝影機進行拍攝與使用軟體進行360度影片之剪接後製，以及如何使用網頁虛擬實境框架「Aframe」製作出互動作品，並協助學生於期中與期末發表個人的虛擬實境藝術創作。",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p6.jpg")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p7.jpg")
                  }
                ],
                options: {
                  isFixedHeight: true
                }
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p1.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p2.png")
                  },
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p3.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p4.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/panorama/p5.png")
                  },
                ]
              },
            ],
          }
        },
        {
          id: 8,
          workType: "work",
          workTitle: {
            en: "A View Outside",
            zh: "小島窗光"
          },
          workInfo: "//website",
          workImg: require("@/assets/images/a-view-outside/cover.png"),
          workDetail: {
            info: [
              "Role: web dev / user experience design",
              "Media: html5 / GSAP / firebase",
              "",
              "This \"Window Exchange Project\" is a video platform created for people affected by the epidemic in Taiwan, and I am responsible for the front and backend development and interactive design of the website. This project invites people to appreciate the light outside other people's windows, to communicate and share the view in front of them, to move from one window to another, to keep each other company and to rest with each other.",
              "",
              "為了受疫情紛擾的台灣人們而製作的「交換窗戶計畫」影音平台，擔任網站前後端開發與互動設計。此項藝術計畫歡迎大家欣賞別人窗邊的風光明媚，以及交換分享自己眼前的風景，一同從這扇窗到那面窗，陪伴彼此、獲得彼此喘息。",
              "",
              "> <a href='https://a-view-outside.com/' target='_blank'>website</a>",
              "> <a href='https://blow.streetvoice.com/55417/' target='_blank'>interview</a>"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/a-view-outside/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/a-view-outside/p1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/a-view-outside/p2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/a-view-outside/p3.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/a-view-outside/yt.jpg"),
                id: "XSrRkdr3nO4"
              }
            ]
          }
        },
        {
          id: 7,
          workType: "work",
          workTitle: {
            en: "My shadow my shelter",
            zh: "你的影子是我的海"
          },
          workInfo: "//website",
          workImg: require("@/assets/images/myshadow-myshelter/cover.jpg"),
          workDetail: {
            info: [
              "Role: web dev / user experience design / sound design",
              "Media: html5 / firebase",
              "",
              "為詩人王小苗與歌手吳青峰合作之歌曲製作的互動體驗網站，擔任網站前後端開發、互動設計、音效設計，體驗者必須走動才能夠看見與聽見歌曲相關之內容，藉此鼓勵體驗者散步與放鬆，上線一周即累積超過13萬之瀏覽人次。",
              "",
              "> <a href='https://myshadow-myshelter.com/' target='_blank'>website</a>",
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p1.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p2.png")
                  },
                  {
                    type: "video",
                    data: require("@/assets/images/myshadow-myshelter/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/myshadow-myshelter/v2.mp4")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p3.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p4.png")
                  },
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p6.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/myshadow-myshelter/p7.png")
                  },
                ]
              },
            ],
          }
        },
        {
          id: 1,
          workType: "work",
          workTitle: {
            en: "Recursive Virtuality",
            zh: "遞迴虛境"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/work1/cover.png"),
          workDetail: {
            info: [
              "Role: overall design / program dev / curation / film",
              "Media: 3D digital image / virtual reality device / gesture recognition device / Unity Engine / computer",
              "",
              "\"Recursive Virtuality\" is a virtual reality interactive work, showing the virtual world of infinite recursion. By wearing the VR device, the viewer can sneak into the depths of the virtual world again and again. The form and consciousness are disintegrated with the retreating imaginary layer, until there is only points and wireframes left in front of eyes and once again fall back into the recursion.",
              "\"Recursive Virtuality\" was exhibited for the first time at the Taipei Synthetic Media Arts Festival and was invited to participate in the Athens Digital Arts Festival.",
              "",
              "《遞迴虛境》是一件虛擬實境互動作品，核心概念為無限遞迴的虛擬世界。觀者可以在虛擬實境中一次次戴上VR頭盔、潛進虛擬世界的深處，形體與意識隨著遞迴的虛境層層剝落溶解，直到眼前的一切只剩點與線，並再一次墜入遞迴。",
              "《遞迴虛境》於台北合成媒體藝術節首次展出，並受邀參加雅典數位藝術節。",
              "",
              "photo credits: 合成媒體藝術節"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work1/1.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/work1/2.png")
                  }
                ],
                options: {
                  isFixedHeight: true
                }
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work1/3.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work1/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work1/4.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/work1/5.png"),
                id: "lp0wTQKyJdk"
              }
            ]
          }
        },
        {
          id: 2,
          workType: "work",
          workTitle: {
            en: "art-reactionary",
            zh: "文藝反動"
          },
          workInfo: "//digital art",
          workImg: require("@/assets/images/work2/1.png"),
          workDetail: {
            info: [
              "Role: overall design, program  dev, curation",
              "Media: html5 / AR.js / three.js / firebase / mobile phone / television",
              "",
              "\"art-reactionary\" is a experiment about art combined with augmented reality and digital interaction. Give all the power of creation to the viewer, and let all collisions and contradictions appear and record in the virtual space. What will happen in this 48-hour co-creation? How will people react to this? And the most important thing is: Can this be called art?",
              "\"art-reactionary\" works in the form of several white frames hanging on the wall. The frame is not a painting but a two-dimensional bar code. The viewer can picks up his mobile phone and enters the website. With the barcode, the AR canvas corresponding to the frame will appear on the screen of the mobile phone. The viewer can use the finger to swipe on the screen to participate in the painting on the canvas. The content of the painting is created by all the viewers. The viewers can also cover and destroy each other's paintings. In addition to the live AR experience, the online website can also allow people who are not at the exhibition making paintings together. The paintings will be displayed on the TV screen in the center of the exhibition.",
              "\"art-reactionary\" was first exhibited at the Taipei Nuit Blanche and was held in Samsung Studio for a month's installation.",
              "",
              "《文藝反動》是一個結合擴增實境與數位互動，關於藝術的叛逆實驗。將創作的權力全部交給觀者，讓所有碰撞與矛盾在虛擬的空間顯現並加以記錄。在這為期四十八小時的共同創作裡，會有什麼事情發生？人們對此的反應又會是？最重要的是：這能被稱之為藝術嗎？",
              "《文藝反動》作品形式為掛於牆上的數個白色畫框，畫框中放置的並非畫作而是二維條碼(Barcode)，體驗者拿起自己的手機進入作品網站之後開啟攝像頭對準二維條碼，就會在手機螢幕上出現擴增實境對應該畫框的畫作，體驗者能夠用手指在螢幕上划動以在畫布上參與作畫，畫作的內容是由所有體驗者一同創造，體驗者彼此之間也能覆蓋、破壞對方的作畫，除了現場的擴增實境體驗，也提供線上網站可以讓不在展覽現場的人進行共同作畫。而所有展覽現場和線上的體驗者作畫的內容，皆會即時顯示於展場中央的電視螢幕上，作為作品展示於眾人面前。",
              "《文藝反動》於台北白晝之夜首次展出，並與三星合作、於Samsung Studio進行一個月的裝置展出。",
              "",
              "photo credits: 黃植琨"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work2/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work2/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work2/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work2/3.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work2/v2.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work2/4.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/work2/5.png"),
                id: "NZtG8bNFRPk"
              },
              {
                img: require("@/assets/images/work2/6.png"),
                id: "TWf-U6GJrfw"
              }
            ]
          }
        },
        {
          id: 3,
          workType: "work",
          workTitle: {
            en: "Sensation Gap",
            zh: "體感溫差"
          },
          workInfo: "//website",
          workImg: require("@/assets/images/work3/cover.png"),
          workDetail: {
            info: [
              "Role: web design / web dev",
              "Media: html5 / pixi.js / firebase",
              "",
              "As the web designer and front-end developer of the online curation project \"Sensation Gap\", I used thermal imager as the overall main vision, and used the old computer interface of the 80s as a reference,  create an online exhibition of three digital artworks. The thermal imaging of the artwork interacts with the movement of the mouse as a heat source. The website also sets up an online chat room to encourage viewers to leave messages and write down thoughts or questions.",
              "",
              "擔任線上策展計畫《體感溫差 Sensation Gap》之網站設計與前端開發，以「熱像儀」作為整體主視覺，並將80年代之舊電腦介面作為參考設計網頁佈局，打造出三件線上展出作品之熱成像，透過滑鼠移動作為熱源與之互動。網站還設置了線上聊天室，鼓勵觀眾留言寫下感想或疑問。",
              "",
              "> <a href='https://sensation-gap.com/' target='_blank'>website</a>"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work3/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work3/1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work3/2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work3/v2.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work3/3.png")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/work3/cover.png"),
                id: "ZW_JNp7B7Ts"
              }
            ]
          }
        },
        {
          id: 4,
          workType: "work",
          workTitle: {
            en: "ANIMISM",
            zh: "實物鏈"
          },
          workInfo: "//website",
          workImg: require("@/assets/images/work4/cover.png"),
          workDetail: {
            info: [
              "Role: web dev",
              "Media: html5 / TweenMax",
              "",
              "As the front-end development of the website of OpenHCI's official website \"ANIMISM\" in 2018, I create a technological futuristic one-page website with color animations and a large number of repeated key visual design arrangements.",
              "",
              "擔任OpenHCI 2018年官方網站《實物鏈 ANIMISM》之網站前端開發，以色塊動畫與大量重複之主視覺排列打造充滿科技未來感之一頁式網頁。",
              "",
              "> <a href='http://www.openhci.com/2018/index.html' target='_blank'>website</a>"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work4/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work4/1.png")
                  },
                  {
                    type: "img",
                    data: require("@/assets/images/work4/2.png")
                  },
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work4/v2.mp4")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/work4/cover.png"),
                id: "Om8-e3nksxE"
              }
            ]
          }
        },
        {
          id: 5,
          workType: "work",
          workTitle: {
            en: "Re-examination",
            zh: "倒數七天"
          },
          workInfo: "//short film",
          workImg: require("@/assets/images/work5/cover.png"),
          workDetail: {
            info: [
              "Role: visual design / music arrangement + instrument + vocal",
              "",
              "As the visual design of the short film \"Re-examination\", I produced key visual design, posters, promotion, DVD packaging, etc. I also served as the arranger, lead singer and instrumentalist of the theme song in this film.",
              "\"Re-examination\" won the Special Nomination Art Design Award at the 2017 Formosa International Film Festival, and was selected for the 2018 Taiwan International Women's Film Festival.",
              "",
              "擔任劇情短片《倒數七天 Re-examination》之視覺設計，製作主視覺、海報、宣傳美宣品、光碟包裝等，同時擔任劇中主題曲之編曲、主唱、樂器演奏者。",
              "《倒數七天 Re-examination》獲2017福爾摩沙國際電影節之評審特別提名美術設計獎，並入選2018臺灣國際女性影展。",
              "",
              "photo credits: 李沛芩"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work5/p1.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work5/p2.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work5/p3.png")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work5/v1.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "video",
                    data: require("@/assets/images/work5/v2.mp4")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work5/2.jpg")
                  }
                ]
              },
            ],
            videos: [
              {
                img: require("@/assets/images/work5/cover.png"),
                id: "cIZemuvKa9M"
              },
              {
                img: require("@/assets/images/work5/4.png"),
                id: "TbBas2jyoAM"
              },
            ]
          }
        },
        {
          id: 6,
          workType: "work",
          workTitle: {
            en: "Leon Zheng",
            zh: "鄭興"
          },
          workInfo: "//live concert",
          workImg: require("@/assets/images/work6/cover.jpg"),
          workDetail: {
            info: [
              "Role: bassist / backing vocalist",
              "",
              "As a live performance bassist and backing vocalist of the Chinese singer Leon Zheng (Who get the best newcomer nomination, the annual album nomination, and the best Mandarin album award nomination in 29th Golden Melody Award.), I performed many times in music venues, and participate in some large-scale music festivals in Kenting, Shanghai, Kunming and Xiamen.",
              "",
              "擔任第29屆金曲獎入圍最佳新人、年度專輯、最佳國語專輯獎之華語歌手鄭興Leon Zheng之現場演出貝斯手與合音，於全台各地Live House多次演出，並曾於墾丁、上海、昆明、廈門等城市參與大型音樂節。",
              "",
              "photo credits: 許恩嘉、張凱傑、劉子衡、政大金旋獎、廈門簡單生活節"
            ],
            photos: [
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work6/1.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work6/2.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work6/3.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work6/4.jpg")
                  }
                ]
              },
              {
                imgs: [
                  {
                    type: "img",
                    data: require("@/assets/images/work6/5.jpg")
                  }
                ]
              },
            ],
          }
        },
      ],
      nowWork: {}
    }
  },
  methods: {
    getNowWork: function(){
      if(this.$route.path.split('/').length > 2) {
        let workTitle = this.$route.path.split('/')[2];
        let nowWork = this.works.find(function(work) {
          return work.workTitle.en.toLowerCase().replace(/ /g, '-').replace(/\?/g, '') === workTitle;
        });
        this.nowWork = nowWork;
      }
    }
  },
  mounted() {
    this.getNowWork();
  },
  watch: {
    '$route' () {
      this.getNowWork();
    }
  }
}
</script>

<style lang="sass" scoped>
  #works
    display: flex
    flex-direction: column
    max-width: 900px
    padding: 180px 0
    @media screen and (max-width: 600px)
      padding: 100px 0

  .work-list
    width: 100%
    display: flex
    flex-direction: column
    margin-top: 100px
    .link
      width: 100%

</style>



// WEBPACK FOOTER //
// src/components/Works.vue